module.exports = __webpack_public_path__ + "Server-Default.Ssh.4c180bc23eb039bda034eeafb9849500.hashedasset.svg";